import { useState } from 'react';
import { Outlet, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FlaskConical, ListVideo, Ticket, Bug, LogOut, ImagePlay, Menu, ChevronDown, ChevronRight } from 'lucide-react';
import adminAuthService from '../../services/adminAuthService';
import './AdminLayout.css';

const NAV_GROUPS = [
  {
    label: '互动空间管理',
    icon: LayoutDashboard,
    items: [
      { to: '/admin/streams', label: '直播间列表', icon: ListVideo },
      { to: '/admin/invites', label: '邀请码管理', icon: Ticket },
      { to: '/admin/video-debug', label: '视频调试工具', icon: Bug },
    ],
  },
  {
    label: '模型灰度使用',
    icon: FlaskConical,
    items: [
      { to: '/admin/model-trial', label: '图生视频', icon: ImagePlay },
    ],
  },
];

export default function AdminLayout() {
  const location = useLocation();
  // 默认展开包含当前路由的组
  const defaultOpen = NAV_GROUPS
    .map((g, i) => g.items.some((it) => location.pathname.startsWith(it.to)) ? i : -1)
    .filter((i) => i >= 0);
  const [openGroups, setOpenGroups] = useState(() => new Set(defaultOpen));
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await adminAuthService.logout();
    navigate('/admin/login');
  };

  const closeMobile = () => setMobileOpen(false);

  const toggleGroup = (idx) => {
    setOpenGroups((prev) => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx);
      else next.add(idx);
      return next;
    });
  };

  return (
    <div className="admin-layout">
      <button className="sidebar-mobile-btn" onClick={() => setMobileOpen(true)}>
        <Menu size={20} />
      </button>

      <div
        className={`sidebar-mobile-overlay ${mobileOpen ? 'show' : ''}`}
        onClick={closeMobile}
      />

      <aside className={`admin-sidebar ${mobileOpen ? 'mobile-open' : ''}`}>
        <nav className="sidebar-nav">
          {NAV_GROUPS.map((group, idx) => {
            const isOpen = openGroups.has(idx);
            return (
              <div key={group.label} className="sidebar-group">
                <button
                  className={`sidebar-group-title ${isOpen ? 'open' : ''}`}
                  onClick={() => toggleGroup(idx)}
                >
                  <span className="sidebar-group-title-left">
                    <group.icon size={15} />
                    <span>{group.label}</span>
                  </span>
                  {isOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                </button>
                <div className={`sidebar-sub ${isOpen ? 'open' : ''}`}>
                  {group.items.map((item) => (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      end={item.to === '/admin/streams'}
                      className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                      onClick={closeMobile}
                    >
                      <span className="sidebar-item-icon"><item.icon size={18} /></span>
                      <span className="sidebar-item-label">{item.label}</span>
                    </NavLink>
                  ))}
                </div>
              </div>
            );
          })}
        </nav>
      </aside>

      <div className="admin-content">
        <div className="admin-topbar">
          <button className="admin-topbar-logout" onClick={handleLogout}>
            <LogOut size={15} />
            <span>退出</span>
          </button>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
